import React from 'react'
import PropTypes from 'prop-types'
import { Card, Text, Grid, GridItem, Icon, Image, Box } from '@chakra-ui/react'
import { useLanguageContext } from '../../../context/locale.context'
import SVGIcon from '../../../assets/svgIcons'


const getIcon = key => {
	switch (key) {
		case 'asset_phone_number':
			return {
				icon: 'CallBigSvg',
				svgProps: {
					width: '24',
					height: '24',
					viewBox: '0 0 24 24',
				}
			}
		case 'operating_asset_email_id':
			return {
				icon: 'MailBigSvg',
				svgProps: {
					width: '24',
					height: '22',
					viewBox: '0 0 24 22',
				}
			}
		case 'asset_date_of_birth':
			return {
				icon: 'BdayBigSvg',
				svgProps: {
					width: '24',
					height: '24',
					viewBox: '0 0 24 24',
				}
			}
		case 'asset_blood_group':
			return {
				icon: 'BdayBigSvg',
				svgProps: {
					width: '21',
					height: '27',
					viewBox: '0 0 21 27',
				}
			}
		case 'asset_address':
			return {
				icon: 'AddressBigSvg',
				svgProps: {
					width: '19',
					height: '24',
					viewBox: '0 0 19 24',
				}
			}
		default:
			return null
	}
}

const RenderEmpDetailsCard = props => {
	const {
		state: { locale },
	} = useLanguageContext()

	const { empDetails, imgSrc, orgLogoBg } = props

	const details = [
		{ key: 'asset_phone_number', value: empDetails.asset_phone_number },
		{
			key: 'operating_asset_email_id',
			value: empDetails.operating_asset_email_id,
		},
		{ key: 'asset_date_of_birth', value: empDetails.asset_date_of_birth },
		{ key: 'asset_blood_group', value: empDetails.asset_blood_group },
		{ key: 'asset_address', value: empDetails.asset_address },
	]

	return (
		<Card
			maxH='12.5rem'
			w='23.75rem'
			bg='white'
			color='black'
			boxShadow='0px 2px 5px rgba(0, 0, 0, 0.1)'
			borderRadius='10px'
			cursor='pointer'
			p='1rem'
			gap='13px'
		>
			<Grid
				w='100%'
				templateColumns='3fr 1fr'
				gridColumnGap='1rem'
				alignItems='center'
				justifyContent='center'
			>
				<GridItem>
					<Text
						fontWeight='900'
						fontSize='1rem'
						lineHeight='1.375rem'
						color='black'
					>
						{empDetails.employee_first_name}
					</Text>
				</GridItem>
				<GridItem rowSpan={empDetails.asset_type_name ? 3 : 2}>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='center'
						w='3rem'
						h='3rem'
						bg={orgLogoBg}
						borderRadius='5px'
						p='2px'
					>
						{!!imgSrc ?
							<Image
								src={imgSrc}
								filter='brightness(0) invert(1)'
							/>
							:
							<SVGIcon
								iconName='NavbarGreneLogoSvg'
								svgProps={{
									width: '38',
									height: '36',
									viewBox: '0 0 38 36',
								}}
							// pathProps={{ fill: 'white' }}
							/>
						}
					</Box>
				</GridItem>
				{empDetails.asset_type_name && (
					<GridItem>
						<Text
							fontWeight='500'
							fontSize='0.75rem'
							lineHeight='1rem'
							color='black'
						>
							{empDetails.asset_type_name}
						</Text>
					</GridItem>
				)}
				{empDetails.employee_organization && (
					<GridItem>
						<Text
							fontWeight='500'
							fontSize='0.75rem'
							lineHeight='1rem'
							color='black'
						>
							{`@ ${empDetails.employee_organization}`}
						</Text>
					</GridItem>
				)}
			</Grid>
			<Grid
				w='100%'
				templateColumns='5fr'
				templateRows='repeat(2, 1fr)'
				gridColumnGap='1rem'
			>
				{details.length > 0 &&
					details.map(detail => {
						return empDetails.hasOwnProperty(detail.key) ? (
							<GridItem className='empBioData' key={detail.key}>
								{/* <Image
									src={getIcon(detail.key)}
									w='15px'
									h='15px'
									alt={detail.key}
								/> */}
								<SVGIcon
									iconName={getIcon(detail.key).icon}
									svgProps={getIcon(detail.key).svgProps}
									pathProps={{ fill: '#009B76' }}
								/>
								{detail.value ? (
									<Text
										fontWeight='400'
										fontSize='0.75rem'
										lineHeight='1.125rem'
										color='black'
									>
										{detail.key === 'phoneNumber'
											? `${empDetails.asset_phone_country_code} ${detail.value}`
											: detail.value}
									</Text>
								) : (
									<Text color='#000000' opacity='0.8'>
										{locale['Not Available']}
									</Text>
								)}
							</GridItem>
						) : null
					})}
			</Grid>
		</Card>
	)
}

RenderEmpDetailsCard.propTypes = {
	empDetails: PropTypes.object.isRequired,
	imgSrc: PropTypes.string,
}

export { RenderEmpDetailsCard }
